import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import Icon from '@piconetworks/pkg-icon';
import Form from '@piconetworks/pkg-form';
import style from './Date.module.scss.js';

var _excluded = ["meta", "label", "required", "endDateId", "startDateId", "formFieldClassName", "className", "disabled", "datePickerProps", "fieldProps", "input"];
var leftArrow = /*#__PURE__*/React.createElement(Icon.Default.ArrowLeft, {
  height: 24,
  width: 24,
  color: "#7A34FF"
});
var rightArrow = /*#__PURE__*/React.createElement(Icon.Default.ArrowRight, {
  height: 24,
  width: 24,
  color: "#7A34FF"
});
var DateRange = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DateRange, _React$Component);
  function DateRange(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleChangeValue = function (startDate, endDate) {
      var input = _this.props.input;
      _this.setState({
        startDate: startDate,
        endDate: endDate
      }, function () {
        if (input) {
          var start = moment(startDate).startOf('day');
          var end = moment(endDate).endOf('day');
          input.onChange([new Date(start), new Date(end)]);
        }
      });
    };
    _this.state = {
      startDate: moment(props.input && props.input.value[0]).startOf('day'),
      endDate: moment(props.input && props.input.value[1]).endOf('day'),
      focusedInput: null
    };
    return _this;
  }
  var _proto = DateRange.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (!Array.isArray(this.props.input.value)) {
      var startDate = moment().startOf('day');
      var endDate = moment().endOf('day');
      this.props.input.onChange([new Date(startDate), new Date(endDate)]);
    }
  };
  _proto.render = function render() {
    var _cx,
      _this2 = this;
    var _this$state = this.state,
      startDate = _this$state.startDate,
      endDate = _this$state.endDate,
      focusedInput = _this$state.focusedInput;
    var _this$props = this.props,
      meta = _this$props.meta,
      label = _this$props.label,
      required = _this$props.required,
      endDateId = _this$props.endDateId,
      startDateId = _this$props.startDateId,
      formFieldClassName = _this$props.formFieldClassName,
      className = _this$props.className,
      disabled = _this$props.disabled,
      datePickerProps = _this$props.datePickerProps,
      fieldProps = _this$props.fieldProps,
      input = _this$props.input,
      args = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/React.createElement(Form.Field, _extends({
      label: label,
      required: required,
      meta: meta,
      input: input,
      className: formFieldClassName
    }, fieldProps), /*#__PURE__*/React.createElement("div", _extends({
      className: cx(style.datePicker, (_cx = {}, _cx[style.error] = meta && meta.error, _cx), className)
    }, args), /*#__PURE__*/React.createElement(DateRangePicker, _extends({
      navPrev: leftArrow,
      navNext: rightArrow,
      displayFormat: 'MM / DD / YYYY',
      dayAriaLabelFormat: 'MM / DD / YYYY',
      isOutsideRange: function isOutsideRange() {
        return false;
      },
      hideKeyboardShortcutsPanel: true,
      disabled: disabled,
      customArrowIcon: /*#__PURE__*/React.createElement(Icon.Default.ArrowRight2, {
        height: 18,
        width: 18,
        fill: meta && meta.error && focusedInput === null ? '#FF4440' : '#120A20'
      }),
      customInputIcon: /*#__PURE__*/React.createElement(Icon.Default.Calendar2, {
        width: 24,
        height: 24
      }),
      numberOfMonths: 1,
      startDate: startDate,
      startDateId: startDateId,
      endDate: endDate,
      endDateId: endDateId,
      onDatesChange: function onDatesChange(_ref) {
        var startDate = _ref.startDate,
          endDate = _ref.endDate;
        return _this2.handleChangeValue(startDate, endDate);
      },
      focusedInput: focusedInput,
      onFocusChange: function onFocusChange(focusedInput) {
        return _this2.setState({
          focusedInput: focusedInput
        });
      }
    }, datePickerProps))));
  };
  return DateRange;
}(React.Component);
DateRange.defaultProps = {
  disabled: false,
  endDateId: 'End_date_unique_id',
  startDateId: 'Start_date_unique_id'
};
DateRange.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  datePickerProps: PropTypes.object,
  disabled: PropTypes.oneOfType([PropTypes.oneOf(['startDate', 'endDate']), PropTypes.bool]),
  endDateId: PropTypes.string,
  fieldProps: PropTypes.object,
  /** This will be deprecated eventually. Instead pass className to the fieldProps */
  formFieldClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  input: PropTypes.object,
  label: PropTypes.node,
  meta: PropTypes.object,
  required: PropTypes.bool,
  startDateId: PropTypes.string
};

export { DateRange as default };
//# sourceMappingURL=index.js.map
